import React from 'react'
import { useAppDispatch, useAppSelector } from '../redux'
import { useAgent } from '../../providers/AgentProvider'
import { selectPresence, set } from '../../slices/presence'

export const usePresence = () => {
  const dispatch = useAppDispatch()
  const { presence } = useAppSelector(selectPresence)
  const { fetchPresence } = useAgent()

  // receiving presence array on load of socket
  const loadPresence = React.useCallback(
    arr => {
      const list = arr.presence

      for (let user of list) {
        const { id, status } = user
        if (['online', 'away'].includes(user.status)) {
          dispatch(set({ [id]: status }))
        }
      }
    },
    [dispatch]
  )

  const queryPresence = React.useCallback(
    ids => {
      fetchPresence(ids, loadPresence)
    },
    [fetchPresence, loadPresence]
  )

  // receiving presence from socket provider
  const presenceReceived = React.useCallback(
    msg => {
      const { data } = msg
      const { id, status } = data[0]

      // don't add to map if key and value exists
      const existing = presence[id]

      if (existing && existing === status) {
        return
      }

      // need to add to list
      dispatch(set({ [id]: status }))
    },
    [dispatch, presence]
  )

  return { loadPresence, queryPresence, presenceReceived }
}
